import { configurationSchema } from '@user-management/configuration';

export const configuration = configurationSchema.parse({
  mode: import.meta.env.MODE,
  logLevel: import.meta.env.VITE_LOG_LEVEL,
  loginUrl: import.meta.env.VITE_LOGIN_URL,
  graphql: {
    apiUrl: import.meta.env.VITE_GRAPHQL_API_URL,
    defaultFetchPolicy: import.meta.env.VITE_GRAPHQL_DEFAULT_FETCH_POLICY,
  },
  userManagement: {
    internalUserEmailDomains: import.meta.env.VITE_INTERNAL_USER_EMAIL_DOMAINS,
    restrictedUserEmailDomains: import.meta.env.VITE_RESTRICTED_USER_EMAIL_DOMAINS,
  },
});
